/* Zenith theme scripts — no dependencies */
(function () {
  'use strict';

  /* Mobile navigation ---------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var header = toggle.closest('.header');
    if (!header) return;
    var open = header.hasAttribute('open-nav');
    if (open) {
      header.removeAttribute('open-nav');
    } else {
      header.setAttribute('open-nav', '');
    }
    toggle.setAttribute('aria-expanded', String(!open));
  });

  /* Product gallery ------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main] img');
    if (main) {
      main.setAttribute('src', thumb.dataset.full);
      main.setAttribute('srcset', thumb.dataset.srcset || '');
      main.setAttribute('alt', thumb.dataset.alt || '');
    }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
      el.setAttribute('aria-current', String(el === thumb));
    });
  });

  /* Quantity steppers ---------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(step.dataset.qtyStep, 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Variant picker ------------------------------------------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = picker.closest('form');
    var idInput = picker.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-variant-price]');
    var submit = form && form.querySelector('[data-add-button]');

    function selected() {
      return Array.prototype.map.call(
        picker.querySelectorAll('input[type=radio]:checked'),
        function (el) { return el.value; }
      );
    }

    function update() {
      var chosen = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;

      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.dataset.labelAvailable : 'Sold out';
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    update();
  });

  /* Reveal on scroll ----------------------------------------------------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'none';
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(14px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
      io.observe(el);
    });
  }
})();